import React from "react"
import slugify from "slugify"
import clsx from "clsx"
import LazyLoad from "react-lazyload"

import { Asset, Breadcrumb, Decorator, IconButton, RichText } from "components"

function Hero({
  content,
  heroHeading,
  heroContent,
  heroImage,
  heroVideo,
  heroDecorators,
}) {
  const HREF = `/why/`

  let jumpLinks = []
  // extract jumpLinks from content
  content?.forEach(({ __typename, content, header, heading, title }, i) => {
    switch (__typename) {
      case "ContentfulAccordion":
      case "ContentfulCollage":
      case "ContentfulColumnGrid":
      case "ContentfulLocationList":
      case "ContentfulRichText":
      case "ContentfulTextBlock":
      case "ContentfulTimeline":
      case "ContentfulSideBySide":
      case "ContentfulStatGrid":
        {
          // extract ID from content, if relevant
          let id = ""
          let label = ""
          if (content?.raw) {
            let contentParsed = JSON.parse(content.raw)
            if (
              contentParsed?.content &&
              contentParsed?.content[0]?.nodeType?.startsWith("heading")
            ) {
              id = slugify(contentParsed?.content[0]?.content[0]?.value)
              label = contentParsed?.content[0]?.content[0]?.value
            }
          }
          if (title || header || heading) {
            label = title || (header?.heading ? header.heading : heading)
            id = slugify(title || (header?.heading ? header.heading : heading))
          }
          if (id && label) {
            jumpLinks.push({ link: id, label: label })
          }
        }
        break
      default:
        return null
    }
  })

  return (
    <section
      className={clsx(
        "relative pt-10 wrapper md:pt-24 default-grid",
        (heroVideo || heroImage) === null && "lg:pb-36 pb-10"
      )}
    >
      {(heroVideo || heroImage) && (
        <div className="bottom-8 left-8 lg:block absolute hidden h-0">
          <div className="w-96 bg-mineralGray absolute top-0 left-0 h-px origin-left transform -translate-x-8" />
          <div className="bg-mineralGray absolute top-0 left-0 w-32 h-px origin-left transform -rotate-90 translate-y-8" />
        </div>
      )}
      {heroDecorators && heroDecorators[0] && (
        <Decorator
          className="lg:block top-10 lg:-translate-x-1/2 absolute left-0 hidden -translate-x-4"
          asset={heroDecorators && heroDecorators[0].asset}
          size="small"
        />
      )}
      <div
        className={clsx(
          "space-y-6 md:space-y-8 col-span-full",
          (heroVideo || heroImage) === null
            ? "lg:col-span-10"
            : "lg:col-span-6 lg:pb-16"
        )}
      >
        <div className="space-y-4">
          <Breadcrumb label="Why Hearthside" href={HREF} />
          {heroHeading && <h1 className="h1 text-darkPurple">{heroHeading}</h1>}
        </div>
        {heroContent && (
          <RichText className="max-w-3xl" content={heroContent} size="large" />
        )}
        {(heroVideo || heroImage) && (
          <ul className="space-y-6">
            {jumpLinks?.map(({ label, link }, i) => {
              return (
                <li key={`heroNavLink-${i}`}>
                  <IconButton
                    label={label}
                    href={"#" + link}
                    icon="arrow-down"
                    animate="down"
                  />
                </li>
              )
            })}
          </ul>
        )}
      </div>
      {(heroImage || heroVideo) && (
        <div className="col-span-full lg:col-span-6">
          <div className="lg:ml-0 sm:-mx-fluidMargin lg:-mr-fluidMargin xl:-mr-26 relative -mx-6">
            <div className="aspect-w-4 aspect-h-5">
              {heroImage && (
                <Asset
                  asset={heroImage}
                  objectFit="contain"
                  objectPosition={heroVideo ? "right" : "center"}
                  style={{ position: "absolute" }}
                />
              )}
              {heroVideo && (
                <LazyLoad
                  classNamePrefix="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                  once
                >
                  <Asset
                    className="absolute top-0 bottom-0 left-0 right-0 object-contain object-right w-full h-full"
                    asset={heroVideo}
                  />
                </LazyLoad>
              )}
              {heroVideo !== null && (
                <div>
                  <div
                    className="lg:block bg-mineralGray absolute top-0 right-0 hidden w-px h-full origin-left transform translate-x-px"
                    style={{ height: "67%" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default Hero
